export default function ValueProposition() {
  return (
    <section className="bg-black px-6 py-32">
      <div className="mx-auto max-w-6xl">
        <div className="mb-16 text-center">
          <div className="mb-6 h-px w-24 mx-auto bg-gradient-to-r from-transparent via-amber-400 to-transparent" />
          <h2 className="mb-6 font-serif text-4xl font-light text-white md:text-5xl lg:text-6xl">
            What is <span className="italic">Clique?</span>
          </h2>
          <p className="mx-auto max-w-3xl text-lg leading-relaxed text-gray-400">
            Clique is Vancouver's most exclusive, invite-only social network. We curate the city's top influencers, models, athletes, socialites, and high-status individuals into one private community. This isn't networking - it's access to Vancouver's elite social scene.
          </p>
        </div>

        <div className="grid gap-8 md:grid-cols-2">
          <div className="border border-gray-800 bg-gradient-to-br from-gray-900 to-black p-10">
            <div className="mb-6 flex h-16 w-16 items-center justify-center border border-amber-400 bg-transparent">
              <i className="ri-vip-crown-line text-3xl text-amber-400"></i>
            </div>
            <h3 className="mb-4 text-2xl font-light text-white">
              Vancouver's Most Selective Community
            </h3>
            <p className="leading-relaxed text-gray-400">
              Only the city's most successful, interesting, or connected individuals are accepted. We don't host casual meetups or typical networking events - we create premium experiences at elite venues for Vancouver's best crowd.
            </p>
          </div>

          <div className="border border-gray-800 bg-gradient-to-br from-gray-900 to-black p-10">
            <div className="mb-6 flex h-16 w-16 items-center justify-center border border-amber-400 bg-transparent">
              <i className="ri-star-line text-3xl text-amber-400"></i>
            </div>
            <h3 className="mb-4 text-2xl font-light text-white">
              Exclusive Events & Access
            </h3>
            <p className="leading-relaxed text-gray-400">
              Private venue takeovers, luxury rooftop socials, yacht experiences, and invite-only mansion parties. Members connect with Vancouver's elite while gaining access to the city's most exclusive social opportunities.
            </p>
          </div>
        </div>

        <div className="mt-12 border-l-4 border-amber-400 bg-gray-900 p-8 md:p-12">
          <p className="text-xl font-light leading-relaxed text-gray-300 md:text-2xl">
            "Clique is where Vancouver's most influential people connect."
          </p>
        </div>
      </div>
    </section>
  );
}
